class SizeGuide extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('[data-trigger]');
    const dialog = this.querySelector('[data-dialog]');
    const close = this.querySelector('[data-close]');
    if (!trigger || !dialog) return;

    const lock = () => { document.body.style.overflow = 'hidden'; };
    const unlock = () => { document.body.style.overflow = ''; };

    trigger.addEventListener('click', () => {
      dialog.showModal();
      lock();
    });
    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', unlock);
  }
}

customElements.define('size-guide', SizeGuide);
